import { Repository } from "src/firebase/firestore/repository";
import { PaymentTransaction } from "./types/payment-transaction.entity";

class PaymentTransactionRepository extends Repository<PaymentTransaction> {
  constructor() {
    super("payment_transactions");
  }
}

export const paymentTransactionRepository = new PaymentTransactionRepository();
